// props映射文件，做props版本兼容，后续可以提示用户是否将要弃用
export default {
  sex: "gender",
  name: "user.name",
  age: "user.age"
};
